import '../style/Home.css'

import { intro_list } from '../lists/intro_li.js';

export function Home() {

    return(
        <>
            <div className='belly_container'>
                <div className='first_page'><p className='first_link'>Indelebile e per sempre</p></div>
                <div className='intro_container'>
                    {intro_list.map((item,index) => {
                        if (index %2 === 0) {
                            return(
                                <div key={index} className={`intro ${item.cName}`}>
                                    <div className='design_box'><div className='design_paragraph'>{item.title}</div><img className='design_img' src={item.image} alt={item.alt}/></div>
                                    <div className='desc_box'><p className='desc_paragraph'>{item.description}</p>{/*<Link to={item.link} className='desc_link'>{item.link_name}</Link>*/}</div>
                                </div>
                            )
                        } else {
                            return(
                                <div key={index} className={`intro ${item.cName}`}>
                                    <div className='desc_box'><p className='desc_paragraph'>{item.description}</p>{/*<Link to={item.link} className='desc_link'>{item.link_name}</Link>*/}</div>
                                    <div className='design_box'><div className='design_paragraph'>{item.title}</div><img className='design_img' src={item.image} alt={item.alt}/></div>
                                </div>
                            )
                        }
                        
                    })}
                </div>
            </div>
        </>
    );
}